/**
 * @file useViewport.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-03
 * @modified 2026-09-03
 *
 * Is this a phone?
 *
 * matchMedia rather than a resize listener: a resize listener fires on every
 * pixel of a drag and on every iOS URL-bar collapse, where matchMedia fires
 * only when the answer actually changes.
 *
 * Note this TRACKS, unlike isCompactNav in Dashboard.js which is read once at
 * mount and deliberately never updated. The difference is not an inconsistency:
 * isCompactNav records a PREFERENCE (someone collapsed the nav, and a window
 * resize should not overrule them), while this records a FACT ABOUT THE DEVICE.
 * A phone rotated to landscape is still a phone in someone's hand and the
 * layout has to follow it.
 *
 * The landscape clause matters: an iPhone on its side is 844-932px wide, so a
 * width-only query would drop it out of the phone shell mid-session.
 */

import { useState, useEffect } from 'react';

const PHONE_QUERY =
  '(max-width: 768px), (max-height: 500px) and (orientation: landscape)';

export default function useViewport() {
  const [isPhone, setIsPhone] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(PHONE_QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(PHONE_QUERY);
    const onChange = (e) => setIsPhone(e.matches);
    // Re-read on mount in case the viewport changed between the initial state
    // and the effect running.
    setIsPhone(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return { isPhone };
}
